import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ScartiConsuntivoVolumiModel, ScartiConsuntivoVolumiReportModel} from '../../../../models/ScartiConsuntivoVolumiModel';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {Subscription} from 'rxjs';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ConsuntivoVolumiScartoService} from '../service-consuntivo-volumi-scarto/consuntivo-volumi-scarto.service';
import {DomSanitizer} from '@angular/platform-browser';
import * as toastr from 'toastr';
import {HttpHeaders} from '@angular/common/http';
import {Offset} from '../../../../models/Offset';
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {ProviderModel} from '../../../../models/ProviderModel';
@Component({
  selector: 'app-filter-consuntivo-volumi-scarto',
  templateUrl: './filter-consuntivo-volumi-scarto.component.html',
  styleUrls: ['./filter-consuntivo-volumi-scarto.component.scss']
})
export class FilterConsuntivoVolumiScartoComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;

  @Input() reportSection?: boolean;
  @Input() numAnnoMese?: number;
  @Input() numAnnoMeseData?: number;
  @Output() dataFiltered = new EventEmitter<any>();
  @Input() isRecovery?: boolean;

  regionCod: string;
  localCustomerCod: string;
  resourceUnitCod: string;
  designCod: string;
  contractTypeCod: string;
  shareName: string;
  applicationDescription: string;
  providerCod: string;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  filter: ScartiConsuntivoVolumiModel;
  intermittentBool: boolean;

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/csv',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    }),
    responseType: 'application/csv'
  };

  constructor(private loaderService: LoaderService,
              private consuntivoVolumiScartoService: ConsuntivoVolumiScartoService,
              private sanitizer: DomSanitizer,
              private dialog: MatDialog) {
    super();
    const providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    this.numAnnoMese = null;
    this.regionCod = null;
    this.localCustomerCod = null;
    this.resourceUnitCod = null;
    this.designCod = null;
    this.contractTypeCod = null;
    this.shareName = null;
    this.applicationDescription = null;
    this.providerCod = providerSelect.cod;
  }

  ngOnInit() {
    this.filter = new ScartiConsuntivoVolumiModel();
    const lastMonth = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.numAnnoMese = Number(lastMonth.lastUploadedVolume);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
  }

  filterTable(): void {
    this.loaderService.display(true);

    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    this.dataFiltered.emit(this.filter);
  }

  resetTable() {
    this.numAnnoFilterComponent.reset();
    this.localCustomerCod = null;
    if(!this.providerCod.includes('KYN')){
      this.regionCod = null;
    }
    
    this.resourceUnitCod = null;
    this.contractTypeCod = null;
    this.designCod = null; 
    this.shareName = null;
    this.applicationDescription = null;
    this.filter.isRecovery = this.isRecovery;
    // HotFix, Reset resets the provider and theres no way to set it other than top right corner.
    // this.providerCod = null; 

    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.filterTable();
  }

  ngOnDestroy(): void {
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.consuntivoVolumiScartoService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.consuntivoVolumiScartoService.getDownloadCsv(this.fileName)
            .subscribe(data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], {type: 'text/csv'}), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ScartiConsuntivoVolumiReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }

    this.loaderService.display(true);
    this.generateScartiVolumiXlsx(reportFilter);
  }

  generateScartiVolumiXlsx(reportFilter) {
    let fileName = 'Monthly Volumes Errors';
    if (this.filter.isRecovery) {
      fileName = 'Volumes Balance Error';
    }
    this.getNameSubscribe = this.consuntivoVolumiScartoService.getNameGenerateXlsx(this.offset, reportFilter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                {type: this.EXCEL_TYPE}),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], {type: this.EXCEL_TYPE}),
              fileName + ' - ' + currentDate  + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI_SCARTO}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.localCustomerCod = this.localCustomerCod ? this.localCustomerCod : '';
 
    
    this.filter.resourcesUnitCod = this.resourceUnitCod ? this.resourceUnitCod : '';
    this.filter.contractCod = this.contractTypeCod ? this.contractTypeCod : '';
    this.filter.designCod = this.designCod ? this.designCod : '';
    this.filter.shareName = this.shareName ? this.shareName : '';
    this.filter.applicationDescription = this.applicationDescription ? this.applicationDescription : '';
    this.filter.providerCod = this.providerCod ? this.providerCod : '';
    this.loaderService.display(false);
  }

  interceptNumAnnoMeseChange(event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptProviderChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptContractTypeChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRegionChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptLocalCustomerChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptResourceUnitChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptSl1Change(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptSharenameChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptApplicationDescChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }
}
